import { useRef, useEffect } from "react";

const WelcomeScreen = ({
  t,
  loading,
  isWelcomeListening,
  toggleWelcomeSpeech,
  onStartSearch,
  error,
  errorStatus,
  suggestions = [],
}) => {
  const hasClickedSearch = useRef(false);

  useEffect(() => {
    if (!loading) {
      hasClickedSearch.current = false;
    }
  }, [loading]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const input = e.target.elements.welcomeSearchInput.value.trim();
    if (input.length >= 3) {
      if (loading || hasClickedSearch.current) return;
      hasClickedSearch.current = true;
      onStartSearch(input);
    }
  };

  return (
    <div className="chatbot-welcome-container animate__animated animate__fadeIn">
      <div className="welcome-logo-wrapper">
        <img
          src="/assets/images/logo/logo.png"
          alt={t("alarabeyya") || "هيّا إلى العربيّة"}
          className="welcome-logo"
        />
      </div>
      <h1 className="welcome-title">{t("Pages.Chatbot.WelcomeTitle")}</h1>
      <p className="welcome-subtitle">{t("Pages.Chatbot.WelcomeSubtitle")}</p>
      <div className="welcome-search-card">
        {error && (
          <div
            className={`error-panel alert alert-danger d-flex align-items-center p-3 mb-3 gap-3 ${errorStatus || ""
              }`}
            role="alert"
            style={{ borderRadius: "16px", direction: "rtl", textAlign: "right" }}
          >
            <i
              className={
                errorStatus === "api_error"
                  ? "fal fa-robot animate__animated animate__shakeX ml-2"
                  : errorStatus === "server_error"
                    ? "fal fa-server animate__animated animate__shakeX ml-2"
                    : errorStatus === "not_found"
                      ? "fal fa-exclamation-circle animate__animated animate__shakeX ml-2"
                      : "fal fa-wifi-slash animate__animated animate__flash animate__infinite ml-2"
              }
              style={{ fontSize: "20px" }}
            ></i>
            <div style={{ flex: 1 }}>
              <strong style={{ fontFamily: "Cairo, sans-serif", fontSize: "15px" }}>
                {errorStatus === "api_error"
                  ? t("Pages.Chatbot.AiError")
                  : errorStatus === "server_error"
                    ? t("Pages.Chatbot.ServerError")
                    : errorStatus === "not_found"
                      ? t("Pages.Chatbot.NotFoundError")
                      : t("Pages.Chatbot.ConnectionError")}
              </strong>
              <span
                className="d-block mt-1 small"
                style={{ fontFamily: "Cairo, sans-serif", fontSize: "13px" }}
              >
                {errorStatus !== "not_found" && error}
              </span>
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit} className="welcome-search-form">
          <div
            className={`welcome-input-group-bar ${isWelcomeListening ? "welcome-input-listening" : ""
              } ${loading ? "welcome-input-disabled" : ""}`}
          >
            <button
              type="button"
              className={`welcome-mic-group-btn ${isWelcomeListening ? "welcome-mic-listening" : ""
                }`}
              onClick={toggleWelcomeSpeech}
              disabled={loading}
              title={
                isWelcomeListening
                  ? t("Pages.Chatbot.Listening") || "جاري الاستماع..."
                  : t("Pages.Chatbot.SpeakToType") || "تحدث للكتابة"
              }
            >
              <i
                className={
                  isWelcomeListening
                    ? "fas fa-microphone animate__animated animate__pulse animate__infinite"
                    : "fal fa-microphone"
                }
              ></i>
              <span className="welcome-mic-group-label">
                {isWelcomeListening
                  ? t("Pages.Chatbot.Listening") || "استماع..."
                  : t("Pages.Chatbot.VoiceLabel") || "صوت"}
              </span>
            </button>
            <div className="welcome-input-divider"></div>
            <input
              name="welcomeSearchInput"
              type="text"
              className="welcome-search-input"
              placeholder={t("Pages.Chatbot.WelcomeSearchPlaceholder")}
              required
              autoComplete="off"
              disabled={loading}
            />
            <button
              type="submit"
              className="welcome-send-group-btn"
              disabled={loading}
            >
              <span>{t("Pages.Chatbot.Start")}</span>
              <i className="fal fa-arrow-left"></i>
            </button>
          </div>
        </form>
        {!loading && suggestions.length > 0 && (
          <div className="welcome-suggestions-section">
            <span className="suggestions-label">
              <i className="fal fa-sparkles"></i>
              {t("Pages.Chatbot.SuggestionsLabel")}
            </span>
            <div className="welcome-suggestions-list">
              {suggestions.map((item, idx) => (
                <button
                  key={idx}
                  type="button"
                  className="welcome-suggestion-item animate__animated animate__fadeInUp"
                  style={{ animationDelay: `${idx * 0.05}s` }}
                  onClick={() => {
                    if (loading || hasClickedSearch.current) return;
                    hasClickedSearch.current = true;
                    onStartSearch(item.text, item.topicId);
                  }}
                  disabled={loading}
                >
                  <i className={item.icon}></i>
                  <span>{item.text}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeScreen;
